import { render, staticRenderFns } from "./VideoScreenNoSpeakers.vue?vue&type=template&id=1699bf29&"
import script from "./VideoScreenNoSpeakers.vue?vue&type=script&lang=js&"
export * from "./VideoScreenNoSpeakers.vue?vue&type=script&lang=js&"
import style0 from "./VideoScreenNoSpeakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports